import { FC, useState } from 'react';
import { ChangeDeliveryDateModalViewType } from '../../../types/view/ChangeDeliveryDateModalViewType';
import changeDeliveryDateModalClass from '../../../assets/scss/ChangeDeliveryDateModal/ChangeDeliveryDateModal.module.scss';
import { noDeliveryTimeText } from '../../../utils/createChangeDeliveryDateModal';

export const ChangeDeliveryTime: FC<{
  changeDeliveryDateModal: ChangeDeliveryDateModalViewType;
  changeDeliveryTimeFunc: (deliveryTime: string) => void;
  clickPullDownEventFunc: () => void;
}> = ({ changeDeliveryDateModal, changeDeliveryTimeFunc, clickPullDownEventFunc }) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  const selected = changeDeliveryDateModal.enableDeliveryTimes.find(
    (times) => times.tag === changeDeliveryDateModal.deliveryTime
  );

  return (
    <div className={changeDeliveryDateModalClass.field}>
      <span className={changeDeliveryDateModalClass.fieldTitle}>お届け時間</span>
      <div
        className={changeDeliveryDateModalClass.selectTime}
        style={{ borderRadius: isOptionsOpen ? '4px 4px 0 0' : '4px' }}
        onClick={() => {
          setIsOptionsOpen((prev) => !prev);
          clickPullDownEventFunc();
        }}
      >
        <span className={changeDeliveryDateModalClass.selectText}>
          {selected?.title ?? noDeliveryTimeText}
        </span>
        <span className={changeDeliveryDateModalClass.pipe} />
        <span className={changeDeliveryDateModalClass.lowerTriangle} />

        {isOptionsOpen && (
          <div className={changeDeliveryDateModalClass.optionsWrapper}>
            {changeDeliveryDateModal.enableDeliveryTimes.map((deliveryTime, idx) => (
              <div
                key={`deliveryTimeOption-${idx}`}
                className={changeDeliveryDateModalClass.option}
                onClick={() => changeDeliveryTimeFunc(deliveryTime.tag)}
              >
                {deliveryTime.title}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
